import { Privileges } from '../../../utils/privileges';
import { PresetAction } from '../types';

// Map URL patterns to required privileges
const URL_PRIVILEGE_MAPPING: Array<{ pattern: RegExp; privilege: string }> = [
  { pattern: /^\/campaigns/i, privilege: Privileges.FUNDRAISER_MANAGE },
  { pattern: /^\/deeds\/campaigns/i, privilege: Privileges.FUNDRAISER_MANAGE },
  { pattern: /^\/deeds\/volunteer/i, privilege: Privileges.EVENT_MANAGE },
  { pattern: /^\/deeds\/events/i, privilege: Privileges.BASE_EVENT_MANAGE },
  { pattern: /^\/deeds\/projects/i, privilege: Privileges.PROJECT_MANAGE },
  { pattern: /^\/events/i, privilege: Privileges.BASE_EVENT_MANAGE },
  { pattern: /^\/projects/i, privilege: Privileges.PROJECT_MANAGE },
  { pattern: /^\/volunteer/i, privilege: Privileges.EVENT_MANAGE },
];

/**
 * Extract navigate URLs from preset actions
 */
export const extractNavigateUrls = (actions: PresetAction[]): string[] => {
  const urls: string[] = [];

  actions.forEach((action) => {
    if (action.type === 'call' && action.data.method === 'navigate') {
      const navigatePayload = action.data.payload as { url?: string };
      if (navigatePayload.url) {
        urls.push(navigatePayload.url);
      }
    }
  });

  return urls;
};

/**
 * Infer required privileges based on navigate URLs in preset actions
 */
export const inferPrivilegesFromActions = (actions: PresetAction[]): string[] => {
  const urls = extractNavigateUrls(actions);
  const privileges = new Set<string>();

  urls.forEach((url) => {
    URL_PRIVILEGE_MAPPING.forEach(({ pattern, privilege }) => {
      if (pattern.test(url)) {
        privileges.add(privilege);
      }
    });
  });

  return Array.from(privileges);
};

/**
 * Get detailed information about which URLs map to which privileges
 */
/**
 * Check if a URL matches any of the privilege patterns
 */
const getPrivilegeForUrl = (url: string): string | null => {
  const matchedMapping = URL_PRIVILEGE_MAPPING.find(({ pattern }) => pattern.test(url));
  return matchedMapping ? matchedMapping.privilege : null;
};

export const getPrivilegeMappingDetails = (
  actions: PresetAction[]
): Array<{ url: string; privilege: string }> => {
  const urls = extractNavigateUrls(actions);
  const mappings: Array<{ url: string; privilege: string }> = [];

  urls.forEach((url) => {
    const privilege = getPrivilegeForUrl(url);
    if (privilege) {
      mappings.push({ url, privilege });
    }
  });

  return mappings;
};
